import { useAuth } from 'react-oidc-context';

// fetch wrapper customized for the most common use case in our app
export const useFetch = () => {
    const baseUrl = "";
    const auth = useAuth();

    async function request(method, url, data) {
        const doFetch = (token) => {
            const headers = {
                'Authorization': 'Bearer ' + token,
            };
            const options = { method, headers };
            if (data !== undefined) {
                headers['Content-Type'] = 'application/json';
                options.body = JSON.stringify(data);
            }
            return fetch(`${baseUrl}${url}`, options);
        };

        let token = auth.user?.access_token;
        let response = await doFetch(token);

        if (response.status === 401) {
            // token likely expired mid-use; try one silent refresh (uses the
            // refresh token) and replay the request before giving up
            const user = await auth.signinSilent();
            token = user?.access_token;
            if (!token) {
                throw new Error("Not signed in");
            }
            response = await doFetch(token);
        }

        return response;
    }

    async function get(url) {
        return request('GET', url);
    }

    async function post(url, data) {
        return request('POST', url, data);
    }

    return {post, get};
}
